<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalWindowsDisplay",
	components: { CaseForm },
	computed: {
		schema() {
			return [
				{
					component: "html",
					props: {
						content: "<div class='fs4 fw7 lh125'>7. (A) How many</div>"
					},
					bindTo: ""
				},
				{
					label: "(a) Windows?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0WindowsQuantityId",
					props: {
						suggest: {
							typeIncludes: "windowsQuantity"
						},
						createOptions: {
							type: "windowsQuantity",
							dataType: "string"
						}
					}
				},
				{
					label: "(b) Outside showcases do you have?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0OutsideShowcasesQuantityId",
					props: {
						suggest: {
							typeIncludes: "outsideShowcasesQuantity"
						},
						createOptions: {
							type: "outsideShowcasesQuantity",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>7. (B) Give MAXIMUM values which will not be exceeded of</div>"
					},
					bindTo: ""
				},
				{
					component: "html",
					props: {
						content: "<div class='fs4 fw7 lh125'>(i) Any one (a) window</div>"
					},
					bindTo: ""
				},
				{
					label: "During business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AnyOneWindowBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneWindowBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneWindowBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Outside business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AnyOneWindowNonBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneWindowNonBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneWindowNonBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(i) Any one (b) outside showcase</div>"
					},
					bindTo: ""
				},
				{
					label: "During business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0AnyOneOutsideShowcaseBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneOutsideShowcaseBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneOutsideShowcaseBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Outside business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0AnyOneOutsideShowcaseNonBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneOutsideShowcaseNonBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneOutsideShowcaseNonBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content: "<div class='fs4 fw7 lh125'>(ii) Any one article</div>"
					},
					bindTo: ""
				},
				{
					label: "During business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AnyOneArticleBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneArticleBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneArticleBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Outside business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AnyOneArticleNonBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneArticleNonBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneArticleNonBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(iii) Any one pad or tray of article</div>"
					},
					bindTo: ""
				},
				{
					label: "During business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0AnyOneArticlePadOrTrayBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneArticlePadOrTrayBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneArticlePadOrTrayBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Outside business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0AnyOneArticlePadOrTrayNonBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "anyOneArticlePadOrTrayNonBusinessHoursMaxValue"
						},
						createOptions: {
							type: "anyOneArticlePadOrTrayNonBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(iv) In all windows & outside showcases</div>"
					},
					bindTo: ""
				},
				{
					label: "During business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0AllWindowsAndOutsideShowcasesBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "allWindowsAndOutsideShowcasesBusinessHoursMaxValue"
						},
						createOptions: {
							type: "allWindowsAndOutsideShowcasesBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Outside business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0AllWindowsAndOutsideShowcasesNonBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes:
								"allWindowsAndOutsideShowcasesNonBusinessHoursMaxValue"
						},
						createOptions: {
							type: "allWindowsAndOutsideShowcasesNonBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
